"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _templateObject, _templateObject2;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginButton = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var react_2 = require("@emotion/react");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_modal_1 = require("@ryerson/frontend.modal");

var LoginForm_1 = __importDefault(require("../Login/LoginForm"));

var MyAccountMenu_1 = __importDefault(require("../Header/MyAccountMenu"));

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var StyledComponents_1 = require("./StyledComponents");

var frontend_modal_2 = require("@ryerson/frontend.modal");

var SwapAccount_1 = __importDefault(require("../Header/SwapAccount/SwapAccount"));

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_theme_2 = require("@ryerson/frontend.theme");

var LoginButton = function LoginButton(_ref) {
  var isPopoverExpanded = _ref.isPopoverExpanded,
      setIsPopoverExpanded = _ref.setIsPopoverExpanded,
      mobileBreakPoint = _ref.mobileBreakPoint,
      isSticky = _ref.isSticky,
      storeDirectory = _ref.storeDirectory;

  var _ref2 = (0, frontend_application_1.useApplication)(),
      language = _ref2.localization.language,
      isLoggedIn = _ref2.user.isLoggedIn;

  var _ref3 = (0, frontend_theme_2.useTheme)(),
      theme = _ref3.theme,
      themeName = _ref3.themeName;

  var _theme$colors = theme.colors,
      _theme$colors$primary = _theme$colors.primary,
      darkGray = _theme$colors$primary.darkGray,
      white = _theme$colors$primary.white,
      lighterGray = _theme$colors$primary.lighterGray,
      accentBrand = _theme$colors$primary.accentBrand,
      red = _theme$colors.secondary.red;

  var _ref4 = (0, react_1.useState)(false),
      _ref5 = _slicedToArray(_ref4, 2),
      modalOpen = _ref5[0],
      setModalOpen = _ref5[1];

  var _ref6 = (0, frontend_application_1.useApplication)(),
      user = _ref6.user;

  var popperRef = react_1.default.useRef(null);
  var backgroundColor = themeName === frontend_theme_1.ThemeNames.ryerson ? getModeColor(darkGray) : getModeColor(accentBrand);

  function getModeColor(normalColor) {
    return isLoggedIn && (user === null || user === void 0 ? void 0 : user.mode) !== "normal" ? red : normalColor;
  }

  var isTouchDevice = function isTouchDevice() {
    if (typeof window !== "undefined" && typeof navigator !== "undefined") {
      return "ontouchstart" in window || navigator.maxTouchPoints > 0;
    } else {
      return false;
    }
  };

  var getTriggerSection = function getTriggerSection() {
    var background = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "primary";
    var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Dashboard";
    var icon = arguments.length > 2 ? arguments[2] : undefined;
    var expanded = arguments.length > 3 ? arguments[3] : undefined;
    var type = arguments.length > 4 ? arguments[4] : undefined;
    var hideChevron = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      className: "popover-menu-root",
      alignItems: "center",
      style: (0, react_2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\t\tpadding: 10px 10px;\n\t\t\t\t"]))),
      onClick: function onClick(event) {
        if (!isLoggedIn && isTouchDevice()) {
          sessionStorage.setItem("redirectTo", window.location.pathname);
          window.location.href = "/login";
          event.stopPropagation();
        }
      },
      "data-testid": "header-login-button-popover",
      children: [icon && (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
        icon: icon,
        size: "xs",
        color: theme.colors[background].header,
        selected: true,
        css: {
          marginRight: "10px"
        }
      }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        className: "login-button-text",
        breakPoint: mobileBreakPoint,
        size: "sm",
        weight: "bold",
        color: white,
        children: trigger
      }), hideChevron && (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
        icon: "chevron-down",
        size: "xs",
        color: theme.colors[background].header,
        selected: true,
        css: {
          marginLeft: "10px",
          transform: !expanded ? "rotate(0deg)" : "rotate(180deg)"
        }
      })]
    });
  };

  var renderAccountPopover = function renderAccountPopover() {
    return (0, jsx_runtime_1.jsx)(frontend_modal_1.Popover, {
      className: "login-account",
      trigger: getTriggerSection("tertiary", frontend_common_1.withTranslation["myAccount"][language], "person", isPopoverExpanded, "caret", !!isLoggedIn),
      offset: [8, 4],
      alignment: "bottom",
      popoverType: "caret",
      caretColor: isLoggedIn ? theme.colors.primary.white : theme.colors.primary.lighterGray,
      onOpen: function onOpen() {
        setIsPopoverExpanded(true);
      },
      onClose: function onClose() {
        setIsPopoverExpanded(false);
      },
      ref: popperRef,
      children: (0, jsx_runtime_1.jsx)(MyAccountMenu_1.default, {
        handleClose: function handleClose(close, isModalOpen) {
          var _a;

          setIsPopoverExpanded(false);
          isModalOpen && setModalOpen(true);
          (_a = popperRef.current) === null || _a === void 0 ? void 0 : _a.close();
        },
        isMobile: false,
        openMyAccountMenu: isPopoverExpanded,
        isSticky: isSticky,
        storeDirectory: storeDirectory
      })
    });
  };

  var renderLoginPopover = function renderLoginPopover() {
    return (0, jsx_runtime_1.jsx)(frontend_modal_1.Popover, {
      className: "login-input",
      trigger: getTriggerSection("tertiary", frontend_common_1.withTranslation["login"][language], isLoggedIn ? "person" : undefined, isPopoverExpanded, "caret", !!isLoggedIn),
      offset: [8, 4],
      alignment: "bottom",
      popoverType: "caret",
      caretColor: isLoggedIn ? theme.colors.primary.white : theme.colors.primary.lighterGray,
      onOpen: function onOpen() {
        setIsPopoverExpanded(true);
      },
      onClose: function onClose() {
        setIsPopoverExpanded(false);
      },
      children: (0, jsx_runtime_1.jsx)(LoginForm_1.default, {
        handleClose: function handleClose(close) {
          return setIsPopoverExpanded(false);
        },
        isMobile: false,
        openLogin: isPopoverExpanded
      })
    });
  };

  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      className: "login-button-container",
      children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        className: "login-button",
        alignItems: "center",
        style: (0, StyledComponents_1.loginText)(backgroundColor),
        children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
          style: (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tborder-color: ", ";\n\t\t\t\t\t\t"])), lighterGray),
          children: [!isLoggedIn && renderLoginPopover(), isLoggedIn && renderAccountPopover()]
        })
      })
    }), (0, jsx_runtime_1.jsx)(frontend_modal_2.Modal, {
      title: frontend_common_1.withTranslation["switchAccounts"][language],
      closable: true,
      isOpen: modalOpen,
      onClose: function onClose() {
        return setModalOpen(false);
      },
      children: (0, jsx_runtime_1.jsx)(SwapAccount_1.default, {
        handleClose: function handleClose() {
          return setModalOpen(false);
        },
        isMobile: false
      })
    })]
  });
};

exports.LoginButton = LoginButton;